import React from 'react';
import { TransProps, useTranslation } from 'react-i18next';

import { RouteNameEnum } from '@onArte/shared/enums';
import { getRouteDetailsByName } from '@onArte/shared/utils';

import { BannerCta, BannerImage, BannerLink, BannerTheme, BannerText, BannerTitle, Container } from './homeBanners.styled';

/**
 * Dwa banery bezpośrednio pod sliderem strony głównej — Załącznik nr 1 poz. 15.
 *
 * Treść jest zwykłym HTML-em (font i przyciski spójne z resztą strony, tekst
 * widoczny dla wyszukiwarek), a ozdobna gwiazdka marki to obrazek z niepustym
 * atrybutem alt, jak wymaga kryterium odbioru. Kreacje graficzne Zamawiającego
 * podmieni się w miejsce tej grafiki. Zwykłe odnośniki <a>, nie nawigacja
 * aplikacji: baner ma być dla robotów linkiem z treścią.
 */
export const HomeBanners: React.FC<{ className?: string }> = ({ className }: { className?: string }): JSX.Element => {
  const { t }: TransProps<never> = useTranslation();

  return (
    <Container className={className}>
      <BannerLink $bannerTheme={BannerTheme.Dark} href={getRouteDetailsByName(RouteNameEnum.ArtworksList)?.url ?? '/dziela'}>
        <BannerImage src='/images/banery/gwiazdka-pomaranczowa.svg' alt={t('onarte.website.homeBanners.artworks.alt')} />
        <BannerTitle>{t('onarte.website.homeBanners.artworks.title')}</BannerTitle>
        <BannerText>{t('onarte.website.homeBanners.artworks.text')}</BannerText>
        <BannerCta $bannerTheme={BannerTheme.Dark}>{t('onarte.website.homeBanners.artworks.cta')}</BannerCta>
      </BannerLink>
      <BannerLink
        $bannerTheme={BannerTheme.Orange}
        href={getRouteDetailsByName(RouteNameEnum.HandbookSeller)?.url ?? '/poradnik-sprzedajacego'}
      >
        <BannerImage src='/images/banery/gwiazdka-czarna.svg' alt={t('onarte.website.homeBanners.handbookSeller.alt')} />
        <BannerTitle>{t('onarte.website.homeBanners.handbookSeller.title')}</BannerTitle>
        <BannerText>{t('onarte.website.homeBanners.handbookSeller.text')}</BannerText>
        <BannerCta $bannerTheme={BannerTheme.Orange}>{t('onarte.website.homeBanners.handbookSeller.cta')}</BannerCta>
      </BannerLink>
    </Container>
  );
};
